import React from "react";
import About from "./About";
import Navbar from "./Navbar";
import Intro from "./Intro";
import SocialIcons from "./SocialIcons";
import FeaturesSection from "./FeaturesSection";
import Experience from "./Experience";
import Contact from "./Contact";
import BlogSection from "./BlogSection";

const Home = () => {
  return (
    <div>
      <Navbar />
      <SocialIcons />
      <Intro />
      <About />
      <Experience />
      <FeaturesSection />
      <BlogSection />
      <Contact />
    </div>
  );
};

export default Home;
